export default {"src":"/_next/static/media/TimeCalendar.3c392e53.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};